// extracted by mini-css-extract-plugin
export default {"area-of-interest":"AreaOfInterest_area-of-interest__WeHpY"};